module.exports = __webpack_public_path__ + "static/media/dog5.75eadc42.jpeg";